import { Camera, Link2, ShieldCheck } from 'lucide-react';
import { useI18n } from '../i18n/useI18n';

const steps = [
  { icon: Camera, title: 'how.step1.title', text: 'how.step1.text' },
  { icon: ShieldCheck, title: 'how.step2.title', text: 'how.step2.text' },
  { icon: Link2, title: 'how.step3.title', text: 'how.step3.text' },
];

export function HowItWorksSection() {
  const { t } = useI18n();

  return (
    <section className="section" id="how-it-works">
      <div className="section-heading">
        <p className="eyebrow">{t('how.eyebrow')}</p>
        <h2>{t('how.title')}</h2>
      </div>
      <div className="steps">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <article className="step-card" key={step.title}>
              <div className="step-card-heading">
                <span className="step-number">{index + 1}</span>
                <Icon size={24} />
                <h3>{t(step.title)}</h3>
              </div>
              <p>{t(step.text)}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}
